import { useRecordContext, ImageField } from 'react-admin';
import * as React from 'react';
import * as getAge from 'get-age';
import { PlayerCard } from '../components';
import playerPlaceholder from '../assets/player-placeholder.svg';
import { getPlayerPhotoUrl } from './playerViewModel';

const avatarStyle = {
  width: 58,
  height: 58,
  borderRadius: 12,
  objectFit: 'cover',
  display: 'block',
};

const SafeAvatar = ({ record, alt = 'avatar' }) => {
  const src = getPlayerPhotoUrl(record, undefined, 'thumbnail') || playerPlaceholder;
  return (
    <img
      style={avatarStyle}
      src={src}
      alt={alt}
      onError={(event) => {
        if (event.currentTarget.src !== playerPlaceholder) event.currentTarget.src = playerPlaceholder;
      }}
    />
  );
};

export const Avatar = (props) => {
  const record = useRecordContext(props);
  return <SafeAvatar record={record} />;
};

export const PlayerAvatar = (props) => {
  const record = useRecordContext(props);
  return <SafeAvatar record={record} alt="Фотография игрока" />;
};

export const PrewAvatar = ({ record, source }) => {
  if (typeof record === 'string') record = { [source]: record };
  return record ? <ImageField record={record} source={source} /> : <img style={avatarStyle} src={playerPlaceholder} alt="Нет фотографии" />;
};

export const Age = (props) => {
  const record = useRecordContext(props);
  return <kbd style={{ fontSize: '1em', color: '#BE1E2D', fontWeight: 'bolder' }}>{record?.age ? `${getAge(record.age)} yrs` : record?.age}</kbd>;
};

export const Age_Card = (props) => {
  const record = useRecordContext(props);
  return <PlayerCard age={record?.age} atk={record?.age ? getAge(record.age) : null} />;
};

export default { Avatar, Age, PlayerAvatar, PrewAvatar };
